import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import logoImg from "../assets/logo2.png"; // ajuste conforme necessário

const traduzirStatus = (status) => {
  switch (status) {
    case "paid": return "Pago";
    case "pending": return "Pendente";
    case "overdue": return "Vencido";
    default: return status || "—";
  }
};

export const exportarPagamentos = (
  pagamentos,
  formato = "pdf",
  titulo = "Relatório de Pagamentos",
  nomeArquivoBase = "pagamentos_exportados",
  nomeEscola = "Escola Vida Abundante",
  emailEscola = "escolavidaabundant7@gmail.com",
  localizacao = "Machava Km 15 Nkomane",
  nuit = "700067254",
  operador = "Usuário Logado",
  desenvolvedor = "Nome do Desenvolvedor"
) => {
  if (!Array.isArray(pagamentos) || pagamentos.length === 0) {
    alert("Nenhum dado para exportar.");
    return;
  }

  const nomeArquivo = `ACADE_Pagamentos ${new Date().toLocaleDateString("pt-AO").replace(/\//g, "-")}`;

  const colunas = [
    "Código", "Aluno", "Referência", "Classe", "Turma", "Serviço",
    "Valor", "Forma Pagamento", "Data/Hora", "Estado"
  ];

  const dadosFormatados = pagamentos.map(pg => {
    const normalizar = v => (v !== undefined && v !== null && v !== "" ? v : "—");

    return {
      "Código": normalizar(pg.code || pg.id),
      "Aluno": normalizar(pg.student || pg.nomeAluno || pg.aluno?.nome || pg.nome_aluno),
      "Referência": normalizar(pg.reference || pg.referencia || pg.mes),
      "Classe": normalizar(pg.class || pg.classe || pg.ano),
      "Turma": normalizar(pg.turma || pg.nomeTurma || pg.nome_turma),
      "Serviço": normalizar(pg.type || pg.servico || pg.serviço),
      "Valor": `MZN ${Number(pg.amount || pg.valor || 0).toLocaleString("pt-AO")}`,
      "Forma Pagamento": normalizar(pg.paymentMethod || pg.formaPagamento || pg.forma_pagamento),
      "Data/Hora": pg.datetime ? new Date(pg.datetime || pg.data_pagamento).toLocaleString("pt-AO") : "—",
      "Estado": traduzirStatus(pg.status),
    };
  });

  if (formato === "pdf") {
    const doc = new jsPDF("landscape");
    const img = new Image();
    img.src = logoImg;

    img.onload = () => {
      const imgWidth = 40;
      const imgHeight = (img.height * imgWidth) / img.width;
      doc.addImage(logoImg, "PNG", 10, 8, imgWidth, imgHeight);

      // Cabeçalho (lado esquerdo)
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text("ACADE – Gestor Escolar", 60, 15);

      doc.setFont("helvetica", "italic");
      doc.setFontSize(12);
      doc.text("Relatório de Pagamentos", 60, 23);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.text(nomeEscola, 60, 30);
      doc.text(`Email: ${emailEscola}`, 60, 36);
      doc.text(`Localização: ${localizacao}`, 60, 42);
      doc.text(`NUIT: ${nuit}`, 60, 48);

      // Cabeçalho (lado direito) — data/hora e operador juntos alinhados à direita
      const now = new Date().toLocaleString("pt-AO");
      doc.text(`Data: ${now}`, 270, 15, { align: "right" });
      doc.text(`Operador: ${operador}`, 270, 21, { align: "right" });

      autoTable(doc, {
        head: [colunas],
        body: dadosFormatados.map(item => colunas.map(col => item[col])),
        startY: 55,
        styles: { fontSize: 10, cellPadding: 3 },
        headStyles: {
          fillColor: [22, 160, 133],
          textColor: 255,
          halign: "center"
        },
        didDrawPage: (data) => {
          const pageHeight = doc.internal.pageSize.height;
          const pageWidth = doc.internal.pageSize.width;
          const pageNumber = doc.internal.getNumberOfPages();

          // Rodapé - linha principal
          doc.setFont("helvetica", "normal");
          doc.setFontSize(9);
          doc.text(
            `Software: ACADE-Gestor Escolar | Processado por computador. Página ${pageNumber} de ${pageNumber}.`,
            14,
            pageHeight - 15
          );

          // Linha separadora
          doc.setDrawColor(150);
          doc.line(14, pageHeight - 13, pageWidth - 14, pageHeight - 13);

          // Desenvolvedor (direita, abaixo da linha)
          doc.setFont("helvetica", "italic");
          doc.text(`Desenvolvido por ${desenvolvedor}`, pageWidth - 14, pageHeight - 8, { align: "right" });
        },
      });

      doc.save(`${nomeArquivo}.pdf`);
    
   };
  } else if (formato === "excel") {
    const ws = XLSX.utils.json_to_sheet(dadosFormatados, { header: colunas });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Pagamentos");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${nomeArquivo}.xlsx`);
  } else if (formato === "csv") {
    const csvLinhas = [
      colunas.join(","),
      ...dadosFormatados.map(item => colunas.map(col => `"${item[col]}"`).join(","))
    ];
    saveAs(new Blob([csvLinhas.join("\n")], { type: "text/csv;charset=utf-8;" }), `${nomeArquivo}.csv`);
  } else {
    alert("Formato não suportado.");
  }
};

